import { useQuery } from '@apollo/client';
import { GetRiskAssessmentResultConfigByIdsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMemo } from 'react';

import {
  type RiskAssessmentResultConfig,
  riskAssessmentResultConfigSchema,
} from './useGetLatestRiskAssessmentResultConfig';

export const useGetRiskAssessmentResultConfigByIds = (
  ids: string[],
  options?: { skip?: boolean }
) => {
  const { data, loading } = useQuery(
    GetRiskAssessmentResultConfigByIdsDocument,
    {
      variables: { ids },
      skip: options?.skip || ids.length === 0,
      fetchPolicy: 'no-cache',
    }
  );

  const configById = useMemo(() => {
    const map = new Map<string, RiskAssessmentResultConfig>();
    if (!data?.risk_assessment_result_config) {
      return map;
    }
    for (const record of data.risk_assessment_result_config) {
      if (record.Config) {
        map.set(
          record.Id,
          riskAssessmentResultConfigSchema.parse(record.Config)
        );
      }
    }

    return map;
  }, [data]);

  return { configById, loading };
};
